import { render, staticRenderFns } from "./gzhGroups.vue?vue&type=template&id=46a034fd&scoped=true"
import script from "./gzhGroups.vue?vue&type=script&lang=js"
export * from "./gzhGroups.vue?vue&type=script&lang=js"
import style0 from "./gzhGroups.vue?vue&type=style&index=0&id=46a034fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a034fd",
  null
  
)

export default component.exports